import request from '../../libs/request';

export default {
  getCart: (id, token = null, siteId) => {
    return request(`api/v1/${siteId}/carrinho/basket/${id}`).get({ token });
  },

  getRescueCart: (id, siteId) => {
    return request(`api/v1/${siteId}/carrinho/basket/${id}/recuperar`).post();
  },

  getOrders: (siteId, id) => request(`${siteId}/carrinho/${id}/pedidos`, 'ocean').get(),

  changeQuantity: (cartId, productId, typeItem, body, token = null, siteId) => {
    return request(`api/v1/${siteId}/carrinho/basket/${cartId}/${typeItem}/${productId}`).post({ body, token });
  },

  addItem: (id, body, token = null, siteId) => {
    return request(`api/v1/${siteId}/carrinho/basket${id ? `/${id}/add` : ''}`).post({ body, token });
  },

  setCoupon: (id, coupon, token = null, siteId) => {
    return request(`api/v1/${siteId}/carrinho/${id}/cupom/${coupon}`).post({ token });
  },

  removeCoupon: (id, coupon, token = null, siteId) => {
    return request(`api/v1/${siteId}/carrinho/${id}/cupom/${coupon}`).delete({ token });
  },
};
